import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-userdetailspopup',
    templateUrl: './userdetailspopup.component.html',
    styleUrls: ['./userdetailspopup.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule]
})
export class UserdetailspopupComponent {
  @Input() organizationKey = ""
  @Input() userId = ""
  @Input() workpackageKey = ""
  @Input() name = ""
  @Input() email = ""
  @Input() photo = ""
  @Output() foundUsers = new EventEmitter<string[]>();

  showModal = true

  userQuery = ""
  message = ""

  constructor(private firestore: FirestoreService) {

  }

  ngAfterViewInit() {
   // this.firestore.copyUserNames(this.organizationKey)
  }

  searchUsers(query: string) {
    
  }
  
    closeModal() { // closing modal window is done by changing parameter showModal on parent component
      this.foundUsers.emit([]);
    }

    removeUserFromWorkpackage() {
      this.firestore.removeUserFromWorkpackage(this.organizationKey, this.workpackageKey, this.userId).then(() => {
        this.closeModal()
      })
    }
  }
